import { render, staticRenderFns } from "./AccountMandates.vue?vue&type=template&id=c13e5120"
import script from "./AccountMandates.vue?vue&type=script&lang=js"
export * from "./AccountMandates.vue?vue&type=script&lang=js"
import style0 from "./AccountMandates.vue?vue&type=style&index=0&id=c13e5120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports